<template>
  <div class="organization-modify-page">
    <div class="page-header">
      <div class="header-main">
        <h2 class="page-title">企业信息维护</h2>
        <p class="page-desc">请确保企业基础信息、资质附件与联系人信息准确完整</p>
      </div>
    </div>

    <el-card class="page-card" shadow="never">
      <div class="info-card-grid">
        <!-- 基本信息 -->
        <div class="form-section basic-info-card">
          <div class="section-head">
            <h3 class="section-title">基本信息</h3>
            <div class="section-tip" v-if="msgCode == 200">当前状态：{{ getStatusText(dict) }}</div>
          </div>

          <el-form :model="formData" :rules="rules" ref="organizationForm" label-width="120px" class="modern-form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位名称" prop="unitName" required>
                <el-input v-model="formData.unitName" placeholder="请输入单位名称" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.unitName }"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码" prop="creditCode" required>
                <el-input v-model="formData.creditCode" placeholder="请输入统一社会信用代码" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.creditCode }"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="成立时间" prop="establishmentDate" required>
                <el-date-picker v-model="formData.establishmentDate" type="date" placeholder="请选择成立时间"
                  style="width: 100%" :disabled="!isEditMode" :class="{ 'filled-input': formData.establishmentDate }">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="法定代表人" prop="legalRepresentative" required>
                <el-input v-model="formData.legalRepresentative" placeholder="请输入法定代表人" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.legalRepresentative }"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人电话" prop="legalPhone" required>
                <el-input v-model="formData.legalPhone" placeholder="请输入法人电话" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.legalPhone }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位性质" prop="unitType" required>
                <el-select v-model="formData.unitType" placeholder="请选择单位性质" style="width: 100%" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.unitType }">
                  <el-option label="上市企业" value="上市企业"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="行业类型" required>
                <!-- 查看模式：显示文本 -->
                <el-input v-if="!isEditMode" :value="industryText" readonly style="width: 100%"
                  :class="{ 'filled-input': industryText }"></el-input>
                <!-- 编辑模式：显示级联选择器 -->
                <el-cascader v-else ref="industryCascader" v-model="formData.industry" placeholder="请选择所属行业"
                  :props="industryCascaderProps" @change="handleIndustryChange" style="width: 100%"
                  :class="{ 'filled-input': formData.industry && formData.industry.length > 0 }" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册资本(万元)" prop="registeredCapital" required>
                <el-input v-model="formData.registeredCapital" placeholder="请输入注册资本" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.registeredCapital }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="单位所在地" required>
                <div class="location-row">
                  <!-- 查看模式：显示文本 -->
                  <el-input v-if="!isEditMode" :value="regionText" readonly class="region-cascader"
                    :class="{ 'filled-input': regionText }"></el-input>
                  <!-- 编辑模式：显示级联选择器 -->
                  <el-cascader v-else ref="regionCascader" v-model="formData.region" placeholder="请选择省市区"
                    :props="regionCascaderProps" @change="handleRegionChange" class="region-cascader"
                    :class="{ 'filled-input': formData.region && formData.region.length > 0 }" />
                  <el-input v-model="formData.detailedAddress" placeholder="请输入详细地址" class="location-input"
                    :class="{ 'filled-input': formData.detailedAddress, 'error-input': !formData.detailedAddress }"
                    :readonly="!isEditMode"></el-input>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="经营范围" prop="businessScope" required>
                <el-input type="textarea" v-model="formData.businessScope" :rows="4" placeholder="请输入经营范围"
                  :disabled="!isEditMode" :class="{ 'filled-input': formData.businessScope }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>

          <div class="upload-block">
            <div class="upload-block-title">营业执照扫描件</div>
            <div class="upload-container">
              <div v-if="formData.businessLicense" class="uploaded-image-wrapper">
                <div class="uploaded-image">
                  <img :src="formData.businessLicense" alt="营业执照" />
                  <div class="image-actions" v-if="isEditMode">
                    <el-button type="text" @click="removeBusinessLicense">删除</el-button>
                  </div>
                </div>
              </div>

              <div class="upload-area-wrapper" v-if="!formData.businessLicense && isEditMode">
                <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="handleFileChange"
                  accept=".jpg,.jpeg,.png" :disabled="uploading">
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__text">请上传原件扫描件(彩色)<br>只可上传jpg, jpeg, png格式图片,大小不能超过10MB</div>
                  <div class="upload-tip">营业执照示例</div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>

        <!-- 账户信息 -->
        <div class="form-section side-info-card">
          <div class="section-head">
            <h3 class="section-title">账户信息</h3>
          </div>
          <el-form :model="formData" :rules="rules" ref="accountForm" label-width="120px" class="modern-form compact-form">
            <el-row :gutter="12">
              <el-col :span="24">
              <el-form-item label="开户银行名称" prop="bankName" required>
                <el-input v-model="formData.bankName" placeholder="请输入开户银行名称" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.bankName }"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="24">
              <el-form-item label="开户银行行号(12位)" prop="bankCode" required>
                <el-input v-model="formData.bankCode" placeholder="请输入开户银行行号" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.bankCode }"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="24">
              <el-form-item label="基本账户账号" prop="accountNumber" required>
                <el-input v-model="formData.accountNumber" placeholder="请输入基本账户账号" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.accountNumber }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>
        </div>

        <!-- 企业联系人 -->
        <div class="form-section side-info-card">
          <div class="section-head">
            <h3 class="section-title">企业联系人</h3>
          </div>
          <el-form :model="formData" :rules="rules" ref="contactForm" label-width="120px" class="modern-form compact-form">
            <el-row :gutter="12">
              <el-col :span="24">
              <el-form-item label="信息申报责任人" prop="declarant" required>
                <el-input v-model="formData.declarant" placeholder="请输入信息申报责任人" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.declarant }"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="24">
              <el-form-item label="申报人电话" prop="declarantPhone" required>
                <el-input v-model="formData.declarantPhone" placeholder="请输入申报人电话" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.declarantPhone }"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="24">
              <el-form-item label="联系地址" prop="contactAddress" required>
                <el-input v-model="formData.contactAddress" placeholder="请输入联系地址" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.contactAddress }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row :gutter="12">
              <el-col :span="24">
              <el-form-item label="电子邮箱" prop="email" required>
                <el-input v-model="formData.email" placeholder="请输入电子邮箱" :disabled="!isEditMode"
                  :class="{ 'filled-input': formData.email }"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          </el-form>
        </div>
      </div>

      <!-- 底部按钮：仅企业信息不存在时显示提交按钮，提交成功后隐藏 -->
      <div class="form-buttons-fixed" v-if="msgCode !== 200">
        <div class="form-buttons">
          <el-button type="primary" size="medium" @click="handleSave">提交</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { addOrganization, getOrganizationInfo, updateOrganization } from '@/api/user/api'
import RegionUtils from '@/utils/regionUtils'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { getFileList } from '@/api/base/api'

export default {
  name: 'OrganizationModify',
  data() {
    return {
      dict:{},
      msgCode: '9230',
      isEditMode: false, // 是否为编辑模式，默认为查看模式
      fileGuid: '',
      uploadedFileId: '', // 上传成功后的文件ID
      uploading: false, // 上传中状态
      cascaderKey: 0, // 用于强制刷新级联选择器
      formData: {
        id: '',
        // 基本信息
        unitName: '',
        creditCode: '',
        legalRepresentative: '',
        legalPhone: '',
        unitType: '',
        industryType: '',
        establishmentDate: '',
        registeredCapital: '',
        // 地区相关字段
        region: [], // 地区选择数组
        province: '', // 省名称
        provinceCode: '', // 省编码
        city: '', // 市名称
        cityCode: '', // 市编码
        county: '', // 县名称
        countyCode: '', // 县编码
        detailedAddress: '',
        businessScope: '',

        // 行业相关字段
        industry: [], // 行业选择数组
        industryLevel1: '', // 一级行业名称
        industryLevel1Code: '', // 一级行业编码
        industryLevel2: '', // 二级行业名称
        industryLevel2Code: '', // 二级行业编码
        industryLevel3: '', // 三级行业名称
        industryLevel3Code: '', // 三级行业编码

        // 账户信息
        bankName: '',
        bankCode: '',
        accountNumber: '',

        // 企业联系人
        declarant: '',
        declarantPhone: '',
        email: '',
        contactAddress: '',

        // 营业执照
        businessLicense: ''
      },
      rules: {
        unitName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        creditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        legalRepresentative: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' }
        ],
        legalPhone: [
          { required: true, message: '请输入法人电话', trigger: 'blur' }
        ],
        unitType: [
          { required: true, message: '请选择单位性质', trigger: 'change' }
        ],
        industryType: [
          { required: true, message: '请选择行业类型', trigger: 'change' }
        ],
        establishmentDate: [
          { required: true, message: '请选择成立时间', trigger: 'change' }
        ],
        registeredCapital: [
          { required: true, message: '请输入注册资本', trigger: 'blur' }
        ],
        province: [
          { required: true, message: '请选择省份', trigger: 'change' }
        ],
        city: [
          { required: true, message: '请选择城市', trigger: 'change' }
        ],
        district: [
          { required: true, message: '请选择区县', trigger: 'change' }
        ],
        detailedAddress: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        businessScope: [
          { required: true, message: '请输入经营范围', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入开户银行名称', trigger: 'blur' }
        ],
        bankCode: [
          { required: true, message: '请输入开户银行行号', trigger: 'blur' }
        ],
        accountNumber: [
          { required: true, message: '请输入基本账户账号', trigger: 'blur' }
        ],
        declarant: [
          { required: true, message: '请输入信息申报责任人', trigger: 'blur' }
        ],
        declarantPhone: [
          { required: true, message: '请输入申报人电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        contactAddress: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // 地区级联选择器配置
    regionCascaderProps() {
      return RegionUtils.getCascaderProps()
    },
    // 行业级联选择器配置
    industryCascaderProps() {
      return RegionUtils.getCascaderProps('COMPANY_INDUSTRY_CODE')
    },
    // 地区显示文本
    regionText() {
      const parts = []
      if (this.formData.province) parts.push(this.formData.province)
      if (this.formData.city) parts.push(this.formData.city)
      if (this.formData.county) parts.push(this.formData.county)
      return parts.join(' / ')
    },
    // 行业显示文本
    industryText() {
      const parts = []
      if (this.formData.industryLevel1) parts.push(this.formData.industryLevel1)
      if (this.formData.industryLevel2) parts.push(this.formData.industryLevel2)
      if (this.formData.industryLevel3) parts.push(this.formData.industryLevel3)
      return parts.join(' / ')
    }
  },
  mounted() {

    // 初始化表单地区字段
    RegionUtils.initRegionFields(this.formData)
    // 初始化表单行业字段
    RegionUtils.initRegionFields(this.formData, {
      provinceField: 'industryLevel1',
      provinceCodeField: 'industryLevel1Code',
      cityField: 'industryLevel2',
      cityCodeField: 'industryLevel2Code',
      countyField: 'industryLevel3',
      countyCodeField: 'industryLevel3Code',
      regionField: 'industry'
    })
    // 获取企业信息
    this.getOrganizationInfo().then(() => {
      // 企业信息不存在时，自动进入编辑模式
      if (this.msgCode !== 200) {
        this.isEditMode = true
      }
    })
  },
  methods: {

    /**
      * 进入编辑模式
      */
    handleEdit() {
      this.isEditMode = true
      // 切换到编辑模式时，设置级联选择器的值
      this.$nextTick(() => {
        if (this.formData.provinceCode && this.formData.cityCode) {
          const regionArray = this.formData.countyCode
            ? [this.formData.provinceCode, this.formData.cityCode, this.formData.countyCode]
            : [this.formData.provinceCode, this.formData.cityCode]
          this.formData.region = regionArray
        }

        if (this.formData.industryLevel1Code && this.formData.industryLevel2Code) {
          const industryArray = this.formData.industryLevel3Code
            ? [this.formData.industryLevel1Code, this.formData.industryLevel2Code, this.formData.industryLevel3Code]
            : [this.formData.industryLevel1Code, this.formData.industryLevel2Code]
          this.formData.industry = industryArray
        }

        // 强制刷新级联选择器
        this.cascaderKey++
      })
    },

    /**
     * 取消编辑，重新获取数据
     */
    handleCancel() {
      this.isEditMode = false
      this.getOrganizationInfo()
    },

    async getOrganizationInfo() {
      try {
        const res = await getOrganizationInfo()
        this.msgCode = res.code
        if (res.code === 200 || res.code === 0) {
          this.dict = res.data

          const data = res.data
          if (data) {
            console.log('获取到的数据:', JSON.stringify(res.data));
            this.formData.id = data.id
            // 基本信息
            this.formData.unitName = data.unitName || ''
            this.formData.creditCode = data.creditCode || ''
            this.formData.legalRepresentative = data.legalRepresentative || ''
            this.formData.legalPhone = data.legalPhone || ''
            this.formData.unitType = data.unitType || ''
            this.formData.establishmentDate = data.establishmentDate || ''
            this.formData.registeredCapital = data.registeredCapital || ''
            this.formData.businessScope = data.businessScope || ''

            // 地区信息
            this.formData.province = data.province || ''
            this.formData.provinceCode = data.provinceCode || ''
            this.formData.city = data.city || ''
            this.formData.cityCode = data.cityCode || ''
            this.formData.county = data.county || ''
            this.formData.countyCode = data.countyCode || ''
            this.formData.detailedAddress = data.detailedAddress || ''

            // 行业信息
            this.formData.industryLevel1 = data.industryLevel1 || ''
            this.formData.industryLevel1Code = data.industryLevel1Code || ''
            this.formData.industryLevel2 = data.industryLevel2 || ''
            this.formData.industryLevel2Code = data.industryLevel2Code || ''
            this.formData.industryLevel3 = data.industryLevel3 || ''
            this.formData.industryLevel3Code = data.industryLevel3Code || ''

            // 账户信息
            this.formData.bankName = data.bankName || ''
            this.formData.bankCode = data.bankCode || ''
            this.formData.accountNumber = data.accountNumber || ''

            // 企业联系人
            this.formData.declarant = data.declarant || ''
            this.formData.declarantPhone = data.declarantPhone || ''
            this.formData.email = data.email || ''
            this.formData.contactAddress = data.contactAddress || ''

            // 文件信息
            if (data.fileGuid) {
              this.fileGuid = data.fileGuid
              this.getAttachmentList(data.fileGuid)
            }
          }
        } else {
          this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        }
      } catch (error) {
        console.error('获取企业信息失败:', error)
      }
    },

    // 获取附件列表
    async getAttachmentList(fileGuid) {
      if (!fileGuid) {
        return
      }
      try {
        const res = await getFileList(fileGuid)
        if (res.code === 200 && res.data) {
          this.formData.businessLicense = res.data[0].fileUrl
        } else {
        }
      } catch (error) {
        console.error('获取附件列表失败:', error)
      } finally {
      }
    },
    async handleFileChange(file, fileList) {
      // 文件大小验证（10MB）
      const maxSize = 10 * 1024 * 1024
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10MB')
        return
      }
      // 文件格式验证
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png']
      if (!allowedTypes.includes(file.raw.type)) {
        this.$message.error('只支持 jpg、jpeg、png 格式的图片')
        return
      }

      // 创建图片预览URL
      const reader = new FileReader()
      reader.onload = (e) => {
        this.formData.businessLicense = e.target.result
      }
      reader.readAsDataURL(file.raw)

      // 上传文件到服务器
      this.uploading = true
      try {
        await doFileUpload(file.raw, {
          fileBindId: this.fileGuid,
          onSuccess: (response) => {
            console.log('文件上传成功:', response)
            this.uploadedFileId = response.fileId || response.id
            this.$message.success('文件上传成功')
            this.uploading = false
          },
          onError: (error) => {
            console.error('文件上传失败:', error)
            this.$message.error('文件上传失败，请重试')
            this.uploading = false
            // 清除预览
            this.formData.businessLicense = ''
          },
          onProgress: (percent) => {
            console.log('上传进度:', percent)
          }
        })
      } catch (error) {
        console.error('文件上传异常:', error)
        this.$message.error('文件上传失败')
        this.uploading = false
        this.formData.businessLicense = ''
      }
    },

    removeBusinessLicense() {
      // 删除营业执照
      this.formData.businessLicense = ''
      this.uploadedFileId = ''
      this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
    },

    /**
     * 地区选择变化处理
     */
    async handleRegionChange(value) {
      await RegionUtils.handleRegionChange(
        value,
        this.$refs.regionCascader,
        this.formData,
        { enableDebug: false },
        this,
        'REGION_CODE'
      )
    },

    /**
     * 行业选择变化处理
     */
    async handleIndustryChange(value) {
      await RegionUtils.handleRegionChange(
        value,
        this.$refs.industryCascader,
        this.formData,
        {
          provinceField: 'industryLevel1',
          provinceCodeField: 'industryLevel1Code',
          cityField: 'industryLevel2',
          cityCodeField: 'industryLevel2Code',
          countyField: 'industryLevel3',
          countyCodeField: 'industryLevel3Code',
          regionField: 'industry',
          enableDebug: false
        },
        this,
        'COMPANY_INDUSTRY_CODE'
      )
    },

    async handleSave() {
      // 验证所有表单
      const validatePromises = [
        this.$refs.organizationForm?.validate(),
        this.$refs.accountForm?.validate(),
        this.$refs.contactForm?.validate()
      ].filter(Boolean)

      try {
        await Promise.all(validatePromises)
      } catch (error) {
        this.$message.warning('请完善必填信息')
        return
      }

      // 验证营业执照是否上传
      if (!this.formData.businessLicense) {
        this.$message.warning('请上传三证合一扫描件')
        return
      }


      // 准备提交数据
      const submitData = {
        // 基本信息
        unitName: this.formData.unitName,
        creditCode: this.formData.creditCode,
        legalRepresentative: this.formData.legalRepresentative,
        legalPhone: this.formData.legalPhone,
        unitType: this.formData.unitType,
        establishmentDate: this.formData.establishmentDate,
        registeredCapital: this.formData.registeredCapital,
        businessScope: this.formData.businessScope,

        // 地区信息
        province: this.formData.province,
        provinceCode: this.formData.provinceCode,
        city: this.formData.city,
        cityCode: this.formData.cityCode,
        county: this.formData.county,
        countyCode: this.formData.countyCode,
        detailedAddress: this.formData.detailedAddress,

        // 行业信息
        industryLevel1: this.formData.industryLevel1,
        industryLevel1Code: this.formData.industryLevel1Code,
        industryLevel2: this.formData.industryLevel2,
        industryLevel2Code: this.formData.industryLevel2Code,
        industryLevel3: this.formData.industryLevel3,
        industryLevel3Code: this.formData.industryLevel3Code,

        // 账户信息
        bankName: this.formData.bankName,
        bankCode: this.formData.bankCode,
        accountNumber: this.formData.accountNumber,

        // 企业联系人
        declarant: this.formData.declarant,
        declarantPhone: this.formData.declarantPhone,
        email: this.formData.email,
        contactAddress: this.formData.contactAddress,

        // 文件GUID - 用于关联上传的文件
        fileGuid: this.fileGuid
      }
      if (this.msgCode == 200) {
        submitData.id = this.formData.id
      }

      try {
        const res = await (this.msgCode == 200 ? updateOrganization(submitData) : addOrganization(submitData))
        if (res.code === 200 || res.code === 0) {
          this.$message.success(this.msgCode === 200 ? '修改成功' : '保存成功，请等待管理员审核')
          // 切换回查看模式
          this.isEditMode = false
          // 重新获取数据
          setTimeout(() => {
            this.getOrganizationInfo()
          }, 500)
        } else {
          this.$message.error(res.msg || res.message || '保存失败')
        }
      } catch (error) {
        console.error('保存企业信息失败:', error)
        this.$message.error('保存失败，请稍后重试')
      }
    },


    // auditStatus：0 待审核 1 审核通过 2 审核退回

    // 获取状态标签文字
    getStatusText(data) {
      const auditStatus = data.auditStatus
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核退回' + '退回原因' + (data.auditRemark ? '：' + data.auditRemark : '')
      }
      return statusMap[auditStatus] || '未知状态'
    },

  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.organization-modify-page {
  .apply-minimal-gray-theme();
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.header-main {
  min-width: 0;
}

.page-title {
  margin: 0;
  font-size: 26px;
  line-height: 1.3;
  font-weight: 700;
  color: @gray-700;
}

.page-desc {
  margin: 8px 0 0;
  font-size: 13px;
  color: @gray-500;
}

.status-tag {
  border: none;
  font-size: 12px;
  font-weight: 600;
}

.page-card {
  border: 1px solid @gray-200;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

::v-deep .page-card .el-card__body {
  padding: 20px 22px 24px;
}

.info-card-grid {
  display: grid;
  // grid-template-columns: 1.9fr 1fr 1fr;
  // justify-content: start;
  gap: 14px;
}

.basic-info-card {
  min-height: 100%;
}

.side-info-card {
  min-height: 100%;
}

/* 表单区域 */
.form-section {
  border-radius: 10px;
  border: 1px solid @gray-200;
  background: linear-gradient(180deg, #ffffff 0%, #fcfcfc 100%);
  box-shadow: @shadow-sm;
  overflow: hidden;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid @gray-200;
  background: @gray-50;
}

.section-tip {
  color: @primary-color;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.section-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: @gray-700;
}

/* 表单样式 */
.modern-form {
  padding: 18px;
}

.compact-form {
  padding-bottom: 10px;
}

.upload-block {
  margin: 0 18px 18px;
  padding: 14px;
  border-radius: 10px;
  background: @gray-50;
  border: 1px dashed @gray-300;
}

.upload-block-title {
  font-size: 13px;
  font-weight: 600;
  color: @gray-700;
  margin-bottom: 10px;
}

::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__label {
  color: @gray-600;
  font-size: 13px;
  font-weight: 600;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 8px;
  border: 1px solid @gray-300;
  background: #fff;
  color: @gray-700;
  transition: all 0.2s ease;
}

::v-deep .el-input__inner:hover,
::v-deep .el-textarea__inner:hover {
  border-color: darken(@gray-300, 8%);
}

::v-deep .el-input__inner:focus,
::v-deep .el-textarea__inner:focus {
  border-color: @primary-color;
  box-shadow: 0 0 0 3px fade(@primary-color, 12%);
}

::v-deep .el-input__inner[readonly],
::v-deep .el-input__inner[disabled],
::v-deep .el-textarea__inner[readonly],
::v-deep .el-textarea__inner[disabled] {
  background: @gray-100;
  color: @gray-500;
}

/* 上传区域 */
.upload-section {
  background-color: transparent;
  padding: 0;
}

.upload-demo {
  width: 100%;
}

.upload-demo .el-upload {
  width: 100%;
}

.upload-demo .el-upload-dragger {
  width: 100%;
  height: 176px;
  border: 1px dashed @gray-300;
  border-radius: 10px;
  background-color: @gray-50;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.25s ease;
}

.upload-demo .el-upload-dragger:hover {
  border-color: @primary-color;
  background: fade(@primary-color, 4%);
}

.upload-demo .el-icon-plus {
  font-size: 34px;
  color: @gray-400;
  margin-bottom: 10px;
}

.upload-demo .el-upload__text {
  color: @gray-600;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
}

.upload-tip {
  margin-top: 8px;
  color: @gray-500;
  font-size: 12px;
}

/* 底部按钮固定悬浮 */
.form-buttons-fixed {
  position: fixed;
  bottom: 0;
  left: 200px;
  right: 0;
  background: fade(#ffffff, 95%);
  backdrop-filter: blur(8px);
  border-top: 1px solid @gray-200;
  box-shadow: 0 -8px 24px rgba(16, 24, 40, 0.08);
  z-index: 1000;
}

.form-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 14px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.form-buttons .el-button {
  min-width: 118px;
  height: 36px;
  border-radius: 8px;
  font-weight: 600;
}

.form-buttons .el-button--primary {
  background-color: @primary-color;
  border-color: @primary-color;
  box-shadow: 0 8px 18px fade(@primary-color, 30%);
}


/* 单位所在地行样式 */
.location-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.location-select {
  width: 150px !important;
}

.location-input {
  flex: 1 !important;
}

/* 级联选择器样式 */
.region-cascader {
  width: 400px !important;
}



/* 上传容器横向布局 */
.upload-container {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.upload-area-wrapper {
  flex: 1;
  min-width: 280px;
}

.uploaded-image-wrapper {
  width: 280px;
  flex-shrink: 0;
}

.uploaded-image {
  position: relative;
  display: block;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid @gray-200;
  box-shadow: @shadow-sm;
}

.uploaded-image img {
  width: 280px;
  height: 180px;
  object-fit: cover;
  display: block;
}

.image-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.74), rgba(0, 0, 0, 0));
  padding: 8px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.image-actions .el-button {
  color: white;
  padding: 4px 8px;
}

.image-actions .el-button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.organization-modify-page {
  padding-bottom: 75px;
}

::v-deep .el-form-item__label {
  font-size: 12px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .organization-modify-page {
    padding: 14px 14px 88px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 22px;
  }

  .info-card-grid {
    grid-template-columns: 1fr;
  }

  .section-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .location-row {
    flex-wrap: wrap;
  }

  .location-select,
  .location-input,
  .region-cascader {
    width: 100% !important;
  }

  .upload-container {
    flex-direction: column;
  }

  .upload-area-wrapper,
  .uploaded-image-wrapper {
    width: 100%;
  }

  .uploaded-image img {
    width: 100%;
    height: auto;
  }

  .form-buttons-fixed {
    left: 0;
  }

  .form-buttons {
    padding: 10px 12px;
  }

  .form-buttons .el-button {
    flex: 1;
    min-width: 0;
  }
}
</style>
